export default __webpack_public_path__ + "static/media/bg_greeing.b0083505.jpg";